import { useMemo } from "react";
import { useSelector } from "react-redux";
import GuidedFlow from "../../primerUso/GuidedFlow";
import ImportarConfigLocal from "../../importarConfig/ImportarConfigLocal";
import { datosImportados } from "../../importarConfig/configImportada";
import useCobrosHabilitados from "../../hooks/useCobrosHabilitados";
import { datosInicialesBar } from "./barPayload";
import { pasosBar } from "./barPasos";
import { SECCION_DEL_FORMULARIO, crearBar, guardarOpcional } from "./barServicios";

const MODULO = {
  nombre: "Reservas de mesas",
  publicado: "Tus reservas ya están abiertas.",
  resumenReq: "Bar, ubicación, horarios, salón y modo de reserva",
};

/**
 * First run of Reservas de mesas (the negocio has no bar yet): required steps create the bar with the
 * same payload as the bar form, optional steps complete it through the update endpoint.
 * `onTerminar(ctx, seccion)` hands control back to the module; `seccion` is a bar form section id.
 */
const ReservasGuidedFlow = ({ states, onTerminar, onCancelar }) => {
  const negocio = useSelector((s) => s.auth)?.negocio?.nombre || "";
  // Until it is known whether the account can charge, deposits stay locked.
  const { cargando, puedeCobrar } = useCobrosHabilitados();
  const senasBloqueadas = cargando || !puedeCobrar;
  const soloGratis = !cargando && !puedeCobrar;

  const pasos = useMemo(() => pasosBar({ states, senasBloqueadas }), [states, senasBloqueadas]);
  const datosIniciales = useMemo(() => datosInicialesBar(negocio), [negocio]);

  return (
    <GuidedFlow
      modulo={MODULO}
      pasosReq={pasos.req}
      pasosOpc={pasos.opc}
      datosIniciales={datosIniciales}
      accionInicial={({ data, set }) => (
        <ImportarConfigLocal tipo="bar" importado={data.importado} onImport={(config) => set(datosImportados(config))} />
      )}
      onPublicar={(d) => crearBar(d, { soloGratis })}
      onGuardarOpc={guardarOpcional}
      onIrSeccion={(paso, ctx) => onTerminar(ctx, SECCION_DEL_FORMULARIO[paso.id] || null)}
      onIrModulo={(ctx) => onTerminar(ctx, null)}
      onCancelar={onCancelar}
    />
  );
};

export default ReservasGuidedFlow;
